import './index.less';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import classnames from 'classnames';

export default class BadgeItem extends React.Component {
	render() {
		const { badgeId, icon, handleClick, rarity, recentlyAwarded, unlocked } = this.props;

		const lockedClass = unlocked ? null : 'Badge--locked';
		const className = classnames('Badge', 'rarity_' + rarity, lockedClass);

		let recentlyAwardedIcon = null;
		if (recentlyAwarded) {
			recentlyAwardedIcon = <div className="dot" />;
		}

		return (
			<div className={className} key={badgeId} title={_.startCase(badgeId.replace(/-/g, ' '))}>
				<ReactCKImage name={icon} options={{ ignoreDimensions: true }} handleClick={handleClick} />
				{recentlyAwardedIcon}
			</div>
		);
	}
}

BadgeItem.propTypes = {
	badgeId: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	rarity: PropTypes.string,
	handleClick: PropTypes.func,
	unlocked: PropTypes.bool,
	recentlyAwarded: PropTypes.bool
};
